import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import { plusDaysDate, spanishDate } from "../../utils/formatDates";
import { Pagination } from "../../components/Pagination";
import { recordatoriosContext } from "../../containers/RecordatoriosPage";
import ModalEditRecordatorio from "../ModalEditRecordatorio";

const SWAL_THEME = {
  background: "#76236C",
  color: "#fafafa",
  confirmButtonColor: "#19D3C5",
};

export default function RecordatoriosTable({ totalPages, page, setPage, recordatorios }) {
  const rows = Array.isArray(recordatorios) ? recordatorios : [];

  const [modalOpen, setModalOpen] = useState(false);

  const { recordatorioSelected, setRecordatorioSelected, eliminarRecordatorio } =
    useContext(recordatoriosContext);

  const handleEliminar = async (recordatorio) => {
    const confirmed = await Swal.fire({
      title: "¿Eliminar recordatorio?",
      text: "El producto dejará de aparecer en este listado.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      ...SWAL_THEME,
    });
    if (!confirmed.isConfirmed) return;
    const res = await eliminarRecordatorio(recordatorio);
    if (!res?.ok) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo eliminar el recordatorio.",
        ...SWAL_THEME,
      });
    }
  };

  return (
    <>
      <table className="table-auto text-sm">
        <thead>
          <tr className="border-b-2">
            <th className="py-4">Producto</th>
            <th className="py-4">Nombre</th>
            <th className="py-4">Cliente</th>
            <th className="py-4">Teléfono</th>
            <th className="py-4">Mascota</th>
            <th className="py-4">Última compra</th>
            <th className="py-4">Duración en días</th>
            <th className="py-4">Fecha para recordar</th>
            <th className="py-4">Acción</th>
          </tr>
        </thead>
        {rows.length ? (
          <tbody>
            {rows.map((recordatorio) => (
              <tr
                className="border-b-[0.5px]"
                key={`${recordatorio.idVenta}-${recordatorio.idProducto}`}
              >
                <td align="center" className="py-4">
                  <img
                    src={recordatorio.fotoProducto}
                    className={"rounded-md w-10 h-10"}
                    alt={recordatorio.nombreProducto}
                  />
                </td>
                <td align="center" className="py-4">
                  {recordatorio.nombreProducto}
                </td>
                <td align="center" className="py-4">
                  {recordatorio.nombreCliente} {recordatorio.apellidoCliente}
                </td>
                <td align="center" className="py-4">
                  {recordatorio.telefono || "—"}
                </td>
                <td align="center" className="py-4">
                  {recordatorio.nombreMascota || "—"}
                </td>
                <td align="center" className="py-4">
                  {spanishDate(recordatorio.ultimaCompra)}
                </td>
                <td align="center" className="py-4">
                  {Math.round(recordatorio.duracionDias)}
                </td>
                <td align="center" className="py-4">
                  {plusDaysDate(
                    recordatorio.ultimaCompra,
                    Math.floor(recordatorio.duracionDias)
                  )}
                </td>
                <td align="center" className="py-4">
                  <div className="flex flex-wrap justify-center gap-2">
                    <button
                      type="button"
                      className="bg-cyan text-white py-2 px-3 rounded-lg"
                      onClick={() => {
                        setRecordatorioSelected(recordatorio);
                        setModalOpen(true);
                      }}
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      className="bg-pink text-white py-2 px-3 rounded-lg"
                      onClick={() => handleEliminar(recordatorio)}
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan={9} className="py-6 text-center text-gray-600">
                No hay registros de recordatorios
              </td>
            </tr>
          </tbody>
        )}
      </table>
      <Pagination
        currentPage={page}
        onPageChange={setPage}
        totalPages={totalPages}
      />
      {recordatorioSelected && (
        <ModalEditRecordatorio
          backgroundColor={"white"}
          open={modalOpen}
          closeModalFunction={() => {
            setModalOpen(false);
            setRecordatorioSelected(null);
          }}
        />
      )}
    </>
  );
}
